import { render, staticRenderFns } from "./ParametrosBoletinsConteudo.vue?vue&type=template&id=0358ea82&"
import script from "./ParametrosBoletinsConteudo.vue?vue&type=script&lang=js&"
export * from "./ParametrosBoletinsConteudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports